export default "__VITE_PUBLIC_ASSET__0dbc2f1a__"